import * as signalR from "@aspnet/signalr";

export interface EventState {
    subscribedRsvpUpdatedOn: { [index: number ]: number; };
    subscribedToRsvpUpdates: { [index: number ]: boolean; };
    websocket?: signalR.HubConnection;
}

export const initialEventState: EventState = {
    subscribedRsvpUpdatedOn: {},
    subscribedToRsvpUpdates: {},
};



// WEBPACK FOOTER //
// ./src/store/event/EventState.ts